import React from 'react';
import Link from '../../link';

const WholesalePartsHubSidebar: React.FC = () => {
  return (
    <div className="wpc-sidebar">
      <div className="sidebar-group">
        <h3>
          <Link href="/wholesale-parts-hub/parts-overview">
            <a>Parts Overview</a>
          </Link>
        </h3>
        <ul>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-overview#volvo-genuine-parts"
              activeClass="active"
            >
              <a>Volvo Genuine Parts</a>
            </Link>
          </li>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-overview#maintenance-parts"
              activeClass="active"
            >
              <a>Maintenance Parts</a>
            </Link>
          </li>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-overview#volvo-remanufactured-exchange-parts"
              activeClass="active"
            >
              <a>Volvo Remanufactured Exchange Parts</a>
            </Link>
          </li>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-overview#volvo-genuine-classic-parts"
              activeClass="active"
            >
              <a>Volvo Genuine Classic Parts</a>
            </Link>
          </li>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-overview#volvo-genuine-accessories"
              activeClass="active"
            >
              <a>Volvo Genuine Accessories</a>
            </Link>
          </li>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-overview#warranty"
              activeClass="active"
            >
              <a>Warranty</a>
            </Link>
          </li>
        </ul>
      </div>
      <div className="sidebar-group">
        <h3>
          <Link href="/wholesale-parts-hub/parts-ordering">
            <a>Parts Ordering</a>
          </Link>
        </h3>
        <ul>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-ordering#independent-repair-facility"
              activeClass="active"
            >
              <a>Independent Repair Facility</a>
            </Link>
          </li>
          <li>
            <Link
              href="/wholesale-parts-hub/parts-ordering#diy-customer"
              activeClass="active"
            >
              <a>DIY Customer</a>
            </Link>
          </li>
        </ul>
      </div>
      <div className="sidebar-group">
        <h3>
          <Link href="/wholesale-parts-hub/certified-collision">
            <a>Certified Collision Program</a>
          </Link>
        </h3>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .wpc-sidebar {
          padding: 3rem 3rem;
          position: fixed;
          font-family: 'Volvo Novum', sans-serif;
        }

        h3 {
          margin: 0;
        }

        h3 a {
          color: var(--text-primary);
          text-decoration: none;
          transition: all 200ms ease-in-out;
          font-weight: 500;
        }

        h3 a:hover {
          color: var(--interactive-primary);
        }

        ul {
          margin: 1rem 0 1rem;
          list-style: none;
        }

        ul li a {
          color: var(--text-primary);
          text-decoration: none;
          transition: all 200ms ease-in-out;
          font-weight: 400;
          font-size: 14px;
        }

        ul li a:hover {
          color: var(--interactive-primary);
        }

        ul li a.active {
          color: var(--interactive-primary);
          font-weight: 500;
        }

        @media screen and (max-width: 1350px) {
          .wpc-sidebar {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
          }

          .sidebar-group ul {
            padding: 0;
          }
        }

        @media screen and (max-width: 850px) {
          .wpc-sidebar {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};

export default WholesalePartsHubSidebar;
